app.component("patientFileTable", {
	templateUrl: "app/src/js/components/patientFileUploader/patientFileTable.html",
	controller: "patientFileTableController",
	bindings: {
		patient: "=",
		operationNoteList: "=",
		eventCallback: "&",
		registration: "&",
		filesCallback: "&",
		uploadOnly: "@",
		selectionCallback: "&",
	},
});

app.controller("patientFileTableController", [
	"$scope",
	"Session",
	"PatientAPI",
	"$modal",
	"ENV",
	"UploadFileAPI",
	"$filter",
	"NgTableParams",
	"FILE_TYPES",
	"ProgressNoteAPI",
	"OperationAPI",
	"MedicationAPI",
	"SurgeryAPI",
	"FileUploader",
	"$timeout",
	"$q",
	"$state",
	"patientDocumentService",
	"PatientRecordLiveUpdateService",
	"$element",
	"AppointmentAPI",
	"DicomWorklistAPI",
	"toast",
	"DICOM_MODALITIES",
	function (
		$scope, Session, PatientAPI, $modal, ENV, UploadFileAPI,
		$filter, NgTableParams, FILE_TYPES, ProgressNoteAPI, OperationAPI,
		MedicationAPI, SurgeryAPI, FileUploader, $timeout, $q, $state, patientDocumentService,
		PatientRecordLiveUpdateService, $element,
		AppointmentAPI, DicomWorklistAPI, toast, DICOM_MODALITIES
	) {

		// --- CONSTANTS & INITIALIZATION ---
		$scope.MAX_FILES_NUMBER = 4;
		$scope.IMAGE_PDF_OPTIONS = FILE_TYPES.image;
		$scope.WORD_OPTIONS = FILE_TYPES.word;
		$scope.VIDEO_OPTIONS = FILE_TYPES.video;
		$scope.fileOptions = [];
		$scope.DocumentList = [];
		$scope.documentsFailed = false;
		$scope.uploadedFilesFailed = false;
		$scope.checkboxes = { items: {} };
		$scope.selectedFilesError = false;
		$scope.isPreviewLoading = false;
		$scope.upperCaseFirstLetter = patientDocumentService.upperCaseFirstLetter;
		// Read by the template: appending a comment to an op note or injection note needs the
		// permission to write that kind of note.
		$scope.canAppendTo = function (doc) {
			if (doc.document_type === "OPNOTE") {
				return Session.hasPermission("SURGERY_OPERATION_NOTE_WRITE");
			}
			if (doc.document_type === "INJECTION_NOTE") {
				return Session.hasPermission("CLINICAL_INJECTION_NOTE_WRITE");
			}
			return false;
		};

		// Expose service methods to view
		$scope.isDeleteEnabled = patientDocumentService.canDeleteFile;
		$scope.canModifyFile = patientDocumentService.canModifyFile;
		$scope.getHl7OverallStatus = patientDocumentService.getHl7OverallStatus;

		// Expose the viewing permission to the UI so the preview button appears
		$scope.canViewDocument = patientDocumentService.canViewDocument;

		// Restore AngularStrap Popover configurations
		$scope.popoverDownload = { content: "Download Document" };
		$scope.popoverPreview = { content: "Preview File" };
		$scope.popoverAppend = { content: "Append Note" };

		// --- DELEGATE FILE TYPE CHECKERS TO SERVICE ---
		const getFileIdentifier = (item) => {
			if (!item) return '';
			return typeof item === 'string' ? item : (item.name || item.type || '');
		};

		$scope.isImageFile = function (item) { return patientDocumentService.isImageFile(getFileIdentifier(item)); };
		$scope.isPdfFile = function (item) { return patientDocumentService.isPdfFile(getFileIdentifier(item)); };
		$scope.isWordFile = function (item) { return patientDocumentService.isWordFile(getFileIdentifier(item)); };
		$scope.isVideoFile = function (item) { return patientDocumentService.isVideoFile(getFileIdentifier(item)); };

		$scope.popoverFileDelete = function (doc) {
			return { title: $scope.isDeleteEnabled(doc) ? "Delete file" : "You cannot delete this file" };
		};

		$scope.popoverDocDelete = function (doc) {
			if (!doc.document_deleted && isEPrescription(doc)) {
				return { title: "ePrescriptions cannot be deleted" };
			}
			return { title: doc.document_deleted ? "Restore document" : "Delete document" };
		};

		$scope.popoverProcessing = function (doc) {
			return { title: "Processing HL7 Message" };
		};

		$scope.popoverHl7Summary = patientDocumentService.buildHl7PopoverSummary;

		this.$onInit = function () {
			$scope.fileAPI = UploadFileAPI;
			$scope.PA = PatientAPI;
			$scope.PN = ProgressNoteAPI;
			$scope.OperationAPI = OperationAPI;
			$scope.MedicationAPI = MedicationAPI;
			$scope.SurgeryAPI = SurgeryAPI;

			$scope.previewHead = $scope.$ctrl.uploadOnly ? 'Preview' : '';
			$scope.isDicomViewerVisible = Session.practice.practiceFeatures.dicomFeature && !$scope.$ctrl.uploadOnly;
			$scope.canSendWalkIn = $scope.isDicomViewerVisible && Session.hasPermission("PATIENT_DICOM_WORKLIST_SEND");

			this.registration({
				fetch: this.fetchFiles.bind(this),
				preview: this.previewFile.bind(this),
			});

			fetchPatientDocumentsAndFiles();
			subscribeToLiveListChanges();
		};

		/** The patient this table is bound to, or a falsy value while it has none. */
		function boundPatientId() {
			return $scope.$ctrl.patient && $scope.$ctrl.patient.id;
		}

		// Another user's uploads and documents, applied to this list as they happen. The two halves
		// are refreshed separately, the way they are fetched: a file event re-asks for the files only,
		// so a slow documents call is never put in front of a file that has just arrived. Both run in
		// the background - no spinner, and the table keeps the page, sort and filters the user had. The
		// upload-only table has no documents half, so it never asks for that one.
		function subscribeToLiveListChanges() {
			const quietly = { background: true };

			PatientRecordLiveUpdateService.subscribePatientFiles($scope, {
				patientId: boundPatientId,
				reload: function () {
					fetchUploadedFilesOnly(boundPatientId(), quietly);
				},
			});

			PatientRecordLiveUpdateService.subscribeDocuments($scope, {
				patientId: boundPatientId,
				reload: function () {
					if (!$scope.$ctrl.uploadOnly) {
						fetchSystemDocuments(boundPatientId(), quietly);
					}
				},
			});

			// The analyser finished with a file - ours or anyone's. Only that row is re-read and
			// replaced, through the same path the polling below uses when it finds a result, so the
			// rest of the list is untouched. This also stops the poll following that file, and it
			// reaches the tabs the poll never could: anyone else looking at this patient's documents.
			PatientRecordLiveUpdateService.subscribePatientFileAnalysed($scope, {
				patientId: boundPatientId,
				onAnalysed: function (payload) {
					applyAnalysedFileById(payload.fileId);
				},
			});
		}

		/**
		 * Re-reads one file the analyser has finished with and replaces its row. Silent on failure: the
		 * poll, if this session is following the file, will ask again; if not, the list is as it was.
		 */
		function applyAnalysedFileById(fileId) {
			const patientId = boundPatientId();
			if (!fileId || !patientId) {
				return;
			}
			$scope.fileAPI.getFileInfo(patientId, fileId).then(function (resp) {
				if (!isCurrentList(patientId)) return;

				if (applyAnalysedFile(resp.data)) {
					initTableParams();
					buildTableFilters();

					if ($scope.$ctrl.filesCallback) {
						$scope.$ctrl.filesCallback({ uploadedDocuments: angular.copy(uploadedDocuments) });
					}
				}
			}, function () {
				// Deliberately silent - see above. Nothing is logged; the response is a patient file.
			});
		}

		this.fetchFiles = function () {
			fetchPatientDocumentsAndFiles();
		};

		this.previewFile = function (document_id, document_type, file_name, patientId) {
			$scope.previewPDF(document_id, document_type, file_name, patientId);
		};

		// --- DATA FETCHING & MERGING ---

		// The rows are what a download or preview request is built from, so the list has to belong
		// to the patient the component is bound to and nobody else. Two things put someone else's
		// rows on screen: the bound patient changing while the previous patient's list is still up
		// - the binding moves synchronously, the list only once its fetch lands - and a slow
		// response for the previous patient arriving after the new one. So the list is emptied the
		// moment the patient changes, and every fetch is stamped with the patient it was issued
		// for, letting a late response be dropped rather than rendered under whoever is loaded by
		// then.
		let listedPatientId = null;
		let pendingListFetch = null;

		// The list is one timeline built from two independent halves - the documents CatTrax generated
		// and the files someone uploaded. They are kept apart so each can be replaced by its own
		// response without waiting on, or being lost to, the other.
		let systemDocuments = [];
		let uploadedDocuments = [];

		function isCurrentList(requestedPatientId) {
			return listedPatientId === requestedPatientId &&
				!!$scope.$ctrl.patient && $scope.$ctrl.patient.id === requestedPatientId;
		}

		function clearDocumentList() {
			systemDocuments = [];
			uploadedDocuments = [];
			$scope.documentsFailed = false;
			$scope.uploadedFilesFailed = false;
			$scope.DocumentList = [];
			$scope.checkboxes = { items: {} };
			cancelAiAnalysisPoll();
			initTableParams();
			buildTableFilters();
		}

		// Nothing stale is left clickable while the new list is on its way.
		$scope.$watch(function () {
			return $scope.$ctrl.patient && $scope.$ctrl.patient.id;
		}, function (newPatientId, oldPatientId) {
			// Fires once on registration with both the same; $onInit has already asked for that list.
			if (newPatientId === oldPatientId) return;

			clearDocumentList();
			fetchPatientDocumentsAndFiles();
		});

		// More than one thing asks for the list at the same moment - the patient changing here, and
		// the dashboard refreshing once it notices the same change. One list is enough, so the request
		// waits until the turn is over and the repeat asks collapse into it.
		function fetchPatientDocumentsAndFiles() {
			$timeout.cancel(pendingListFetch);
			pendingListFetch = $timeout(fetchListForBoundPatient, 0);
		}

		function fetchListForBoundPatient() {
			pendingListFetch = null;

			if (!$scope.$ctrl.patient || !$scope.$ctrl.patient.id) {
				return;
			}

			const requestedPatientId = $scope.$ctrl.patient.id;
			listedPatientId = requestedPatientId;

			// Both halves are asked for at once and each is drawn as it lands. They used to be
			// chained, which meant the files were only asked for once the documents had come back -
			// a slow documents call held the patient's files off the screen behind it, and a failed
			// one meant they were never asked for at all and the table stayed empty.
			systemDocuments = [];
			uploadedDocuments = [];
			$scope.documentsFailed = false;
			$scope.uploadedFilesFailed = false;

			// The upload-only table is just the patient's files, so there is no second half to ask for.
			if (!$scope.$ctrl.uploadOnly && Session.hasPermission("PATIENT_GENERATED_DOCUMENT_VIEW")) {
				fetchSystemDocuments(requestedPatientId);
			}
			if (Session.hasPermission("PATIENT_FILE_READ")) {
				fetchUploadedFilesOnly(requestedPatientId);
			}
		}

		function fetchSystemDocuments(requestedPatientId, options) {
			const background = !!(options && options.background);
			if (!background) $scope.PA.isProcessing = true;
			// The rejection handler is the second argument rather than a .catch on the end, so it
			// only ever sees the request failing. A .catch there would also swallow anything the
			// success handler threw and report a response that arrived perfectly well as one that
			// never came.
			$scope.PA.fetchDocument(requestedPatientId)
				.then(function (resp) {
					if (!isCurrentList(requestedPatientId)) return;

					systemDocuments = formatSystemDocuments(resp.data);
					renderDocumentList();
				}, function (err) {
					console.error("Error fetching system documents:", err && err.status);
					if (!isCurrentList(requestedPatientId)) return;

					// Said out loud rather than left as a gap. Half a list looks exactly like a
					// complete one, and a clinician reading a patient's documents has no way to tell
					// that the generated ones are missing.
					$scope.documentsFailed = true;
				})
				.catch(function (err) {
					// The response arrived and reading it threw. The documents are just as absent from
					// the list, so it is still called out - but logged as what it actually was.
					console.error("Error building the system document list:", err && err.name);
					if (isCurrentList(requestedPatientId)) $scope.documentsFailed = true;
				})
				.finally(function () {
					if (!background) $scope.PA.isProcessing = false;
				});
		}

		function fetchUploadedFilesOnly(requestedPatientId, options) {
			const background = !!(options && options.background);
			if (!background) $scope.fileAPI.isProcessing = true;
			$scope.fileAPI.getFiles(requestedPatientId)
				.then(function (resp) {
					if (!isCurrentList(requestedPatientId)) return;

					uploadedDocuments = formatUploadedFiles(resp.data);

					// Callback for parent component
					if ($scope.$ctrl.filesCallback) {
						$scope.$ctrl.filesCallback({ uploadedDocuments: angular.copy(uploadedDocuments) });
					}

					renderDocumentList();
				}, function (error) {
					console.error("Error fetching uploaded files:", error && error.status);
					if (!isCurrentList(requestedPatientId)) return;

					$scope.uploadedFilesFailed = true;
				})
				.catch(function (error) {
					console.error("Error building the uploaded file list:", error && error.name);
					if (isCurrentList(requestedPatientId)) $scope.uploadedFilesFailed = true;
				})
				.finally(function () {
					if (!background) $scope.fileAPI.isProcessing = false;
				});
		}

		// Rebuilt from both halves rather than appended to, so it does not matter which of them
		// arrives first, or whether the other arrives at all.
		function rebuildDocumentList() {
			$scope.DocumentList = systemDocuments.concat(uploadedDocuments);
			$scope.DocumentList.sort((a, b) => b.date_time.getTime() - a.date_time.getTime());

			// Initialize Checkboxes
			$scope.DocumentList.forEach(t => $scope.checkboxes.items[t.document_id] = false);
		}

		function renderDocumentList() {
			rebuildDocumentList();
			initTableParams();
			buildTableFilters();
		}

		// --- AI ANALYSIS POLLING ---

		// An uploaded file is handed to the analyser after it is stored, so it lands in the list as
		// AI_ANALYSIS ("AI processing...") and is rewritten with the type it was recognised as a
		// moment later. Rather than leave that showing until the page is reloaded, each file still
		// being analysed is re-read on its own and its row replaced when it is done - the rest of
		// the list, and everything the user has done to it, is left alone.
		const AI_ANALYSIS_POLL_INTERVAL_MS = 5000;
		const AI_ANALYSIS_POLL_WINDOW_MS = 60000;

		let aiAnalysisPoll = null;

		// When to stop asking about each file, keyed by file id. A file is only in here while it is
		// actively being followed, and only ever gets in by being uploaded or edited.
		let aiAnalysisExpiryByFileId = {};

		function isAwaitingAiAnalysis(document) {
			return !!document && document.document_type === 'upload' && document.file_type === 'AI_ANALYSIS';
		}

		/**
		 * Whether a row is one we are currently waiting on a result for - which is what the spinner
		 * beside its name means. A file the analyser reported as failed is not one of these, nor is
		 * one we have stopped following, so neither is left spinning at nothing.
		 *
		 * Read on every digest, so it only reads state - the following set is built where the
		 * polling is decided, not here.
		 */
		$scope.isAnalysisInProgress = function (document) {
			return isAwaitingAiAnalysis(document) &&
				aiAnalysisExpiryByFileId[document.document_id] !== undefined;
		};

		/**
		 * Starts following files while they are analysed. Called with the ids the upload returned,
		 * so what gets checked is exactly what was just uploaded rather than whatever the list looks
		 * like - the list has not necessarily caught up at this point.
		 */
		function watchFilesForAiAnalysis(fileIds) {
			if (!fileIds || fileIds.length === 0) {
				return;
			}

			// Restarts the window on a file already being followed: it has just been handed to the
			// analyser again, so the wait starts from now.
			const expiry = Date.now() + AI_ANALYSIS_POLL_WINDOW_MS;
			fileIds.forEach(function (fileId) {
				if (fileId) {
					aiAnalysisExpiryByFileId[fileId] = expiry;
				}
			});

			scheduleAiAnalysisPoll();
		}

		// The files still worth asking about: only the ones this session uploaded or edited, which
		// are the two things that hand a file to the analyser. Nothing is picked up off the list
		// itself - opening the documents of a patient whose file happens to be mid-analysis does not
		// start anything. Each file is given its own minute, measured from when it was handed over,
		// so one the analyser never finishes drops out without holding up the others.
		function pendingAiAnalysisFileIds() {
			const now = Date.now();

			return Object.keys(aiAnalysisExpiryByFileId).filter(function (fileId) {
				// Given up on: dropped from the following set, which also stops its spinner. Only
				// uploading or editing the file again starts another wait.
				if (now >= aiAnalysisExpiryByFileId[fileId]) {
					delete aiAnalysisExpiryByFileId[fileId];
					return false;
				}
				return true;
			});
		}

		function scheduleAiAnalysisPoll() {
			if (aiAnalysisPoll || pendingAiAnalysisFileIds().length === 0) {
				return;
			}
			aiAnalysisPoll = $timeout(pollAiAnalysisFiles, AI_ANALYSIS_POLL_INTERVAL_MS);
		}

		function pollAiAnalysisFiles() {
			aiAnalysisPoll = null;

			const fileIds = pendingAiAnalysisFileIds();
			if (fileIds.length === 0) {
				return;
			}

			const polledPatientId = boundPatientId();
			if (!polledPatientId) {
				return;
			}

			$q.all(fileIds.map(function (fileId) {
				return $scope.fileAPI.getFileInfo(polledPatientId, fileId)
					.then(function (resp) {
						// The patient changed while this was in flight - the file is not this list's.
						if (!isCurrentList(polledPatientId)) return false;
						return applyAnalysedFile(resp.data);
					})
					// A file that could not be read is simply asked about again on the next pass,
					// until its window runs out. A file that is gone - deleted while we were
					// following it - is not coming back, so stop asking rather than spending the
					// rest of its window on a file that no longer exists.
					.catch(function (resp) {
						if (resp && resp.status === 404) {
							delete aiAnalysisExpiryByFileId[fileId];
						}
						return false;
					});
			})).then(function (results) {
				// Only redrawn when a file actually finished, so a check that found nothing new
				// leaves the table's paging, sorting and filters as the user left them.
				if (!isCurrentList(polledPatientId)) return;

				if (results.some(Boolean)) {
					initTableParams();
					buildTableFilters();

					if ($scope.$ctrl.filesCallback) {
						$scope.$ctrl.filesCallback({ uploadedDocuments: angular.copy(uploadedDocuments) });
					}
				}

				scheduleAiAnalysisPoll();
			});
		}

		/**
		 * Replaces the row of a file the analyser has finished with.
		 *
		 * @return true when the list changed, so the caller knows whether the table is worth redrawing.
		 */
		function applyAnalysedFile(rawFile) {
			if (!rawFile || !rawFile.file_id || rawFile.file_type === 'AI_ANALYSIS') {
				return false;
			}

			// Stop following it either way - it has been analysed, whatever it turned out to be.
			delete aiAnalysisExpiryByFileId[rawFile.file_id];

			// Reformatted through the same mapper the list is built with. It returns nothing for a
			// file this view does not show - a video on the referral screen, say.
			const formatted = formatUploadedFiles([rawFile])[0];

			const index = uploadedDocuments.findIndex(function (document) {
				return document.document_id === rawFile.file_id;
			});

			if (index === -1) {
				// Analysed before the list caught up with the upload, so the row is added rather
				// than replaced. The rebuild sorts it into place, as the list runs newest first.
				if (!formatted) {
					return false;
				}
				uploadedDocuments.push(formatted);
				rebuildDocumentList();
				return true;
			}

			if (formatted) {
				uploadedDocuments[index] = formatted;
			} else {
				// Not shown here any more, so the row goes rather than being left reading
				// "AI processing...".
				uploadedDocuments.splice(index, 1);
				delete $scope.checkboxes.items[rawFile.file_id];
			}

			rebuildDocumentList();
			return true;
		}

		function cancelAiAnalysisPoll() {
			$timeout.cancel(aiAnalysisPoll);
			aiAnalysisPoll = null;
			aiAnalysisExpiryByFileId = {};
		}

		// Leaving the patient's documents behind stops the checks, and any list still to be asked
		// for, with it.
		$scope.$on('$destroy', function () {
			cancelAiAnalysisPoll();
			$timeout.cancel(pendingListFetch);
			pendingListFetch = null;
		});

		// --- REFACTORED FORMAT SYSTEM DOCUMENTS METHOD ---
		function formatSystemDocuments(data) {
			return data.map(t => {
				// Safe contextual string compilation matching original fields
				const combinedDateTimeStr = `${t.document_created_date} ${t.document_created_time}`;

				// Parse with strict formatting configurations matching "DD/MM/YY hh:mm A"
				const calculatedMomentInstance = moment(combinedDateTimeStr, "DD/MM/YY hh:mm A");
				const fallBackJSDate = calculatedMomentInstance.isValid() ? calculatedMomentInstance.toDate() : new Date();

				return {
					...t,
					security_level: t.document_security_type,
					security_level_text: patientDocumentService.formatSecurityLevel(t.document_security_type, '', Session.practice.name),
					pathway: 'Cataract',
					date_time: fallBackJSDate,
					created_date: calculatedMomentInstance.isValid() ? calculatedMomentInstance.startOf('day').toDate() : new Date()
				};
			});
		}

		function formatUploadedFiles(data) {
			const list = [];
			data.forEach(t => {
				if (!t.file_type) return;
				if (t.file_type === 'VIDEO' && $scope.$ctrl.uploadOnly) return;

				// A record this cannot be built from is left out rather than allowed to throw. One
				// unreadable file used to take every other file on the patient down with it, and the
				// more files a patient has the likelier it is that one of them is the odd one out.
				try {
					let document_name = getDocumentName(t);
					// Named by its own file name, the file name underneath would only repeat it.
					const namedByFile = !!ownName(t);
					const zonedDate = moment(t.date_uploaded).tz(Session.practice.timezone);

					list.push({
						document_name: document_name,
						document_created_date: zonedDate.format("DD/MM/YY"),
						document_created_time: zonedDate.format("hh:mm A"),
						document_type: 'upload',
						document_available: true,
						document_id: t.file_id,
						patient_id: t.patient_id,
						pathway: 'Cataract',
						date_time: zonedDate.toDate(),
						created_date: zonedDate.toDate(),
						file_name: namedByFile ? null : patientDocumentService.truncateWithElipsis(t.full_name, 15),
						full_name: t.full_name,
						security_level: t.security_level,
						security_level_text: patientDocumentService.formatSecurityLevel(t.security_level, t.uploaded_by_user_name, t.uploaded_by_practice_name),
						file_upload_date: t.date_uploaded,
						comments: t.comments?.length > 0 ? t.comments : '',
						eye: t.eye,
						file_type: t.file_type,
						uploaded_by_practice_id: t.uploaded_by_practice_id,
						uploaded_by_user_id: t.uploaded_by_user_id,
						uploaded_by_user_roles: t.uploaded_by_user_roles,
						uploaded_by_practice_name: t.uploaded_by_practice_name,
						uploaded_by_user_name: t.uploaded_by_user_name,
						file_mime_type: t.metadata?.file_mime_type,
						// Carried through so the details modal can show the referral's provider details
						// as they stand, and tell whether they were changed.
						referral_data: t.referral_data,
						ai_analysed: t.ai_analysis_file_type != null
					});
				} catch (error) {
					console.error("Skipping an uploaded file that could not be read:", error && error.name);
				}
			});
			return list;
		}

		// An "Other" file says nothing by its type, so it goes by its own name: a lens order PDF reads
		// "Lens order 21 Oct 2026", not "Other OU". The server stores spaces as underscores.
		function ownName(fileData) {
			if (fileData.file_type !== 'OTHER' || fileData.ai_analysis_file_type || !fileData.full_name) return null;
			return fileData.full_name.replace(/\.[A-Za-z0-9]{2,5}$/, '').replace(/_+/g, ' ').trim() || null;
		}

		function getDocumentName(fileData) {
			if (fileData.file_type === 'AI_ANALYSIS') return 'AI processing...';
			if (fileData.file_type === 'AI_ANALYSIS_FAILED') return 'AI processing failed.';
			const own = ownName(fileData);
			if (own) return own;

			let docName = fileData.ai_analysis_file_type
				? `${fileData.ai_analysis_file_type}`
				: patientDocumentService.upperCaseFirstLetter(fileData.file_type.toLowerCase().replaceAll('_', ' '));
			if (fileData.eye) docName += ` ${fileData.eye}`;

			return docName;
		}

		// --- TABLE CONFIGURATION & FILTERS ---

		// The list scrolls rather than pages, so the table always shows "page one" and that page
		// grows as the user reaches the bottom of the section. Only the rows in that window are in
		// the DOM, which is what keeps a patient with hundreds of documents cheap to open - all of
		// them are already in memory (both endpoints return the lot), it is the rows, popovers and
		// spinners that cost.
		const DOCUMENTS_WINDOW_SIZE = 25;
		let visibleDocumentCount = DOCUMENTS_WINDOW_SIZE;

		function initTableParams() {
			if ($scope.tableParams) {
				$scope.tableParams.settings({ dataset: $scope.DocumentList });
				// The window is deliberately left where the user had it: a refresh (an upload, a
				// delete, or an analysed file landing) redraws the same rows they were looking at
				// rather than snapping them back to the top of the list.
				$scope.tableParams.parameters({ count: visibleDocumentCount, page: 1 });
				$scope.tableParams.reload();
			} else {
				$scope.tableParams = new NgTableParams({ count: visibleDocumentCount }, {
					counts: [],
					filterOptions: { filterComparator: applyComparer },
					dataset: $scope.DocumentList,
				});
			}
		}

		// How many rows the current filter matches - not the whole list, so the "scroll for more"
		// hint disappears once a filter has narrowed things down to what is already shown.
		function matchingDocumentCount() {
			const total = $scope.tableParams && $scope.tableParams.total();
			return angular.isNumber(total) ? total : $scope.DocumentList.length;
		}

		$scope.remainingDocumentCount = function () {
			return Math.max(matchingDocumentCount() - visibleDocumentCount, 0);
		};

		$scope.hasMoreDocuments = function () {
			return $scope.remainingDocumentCount() > 0;
		};

		// Called by the scrolled-to-bottom directive on the list container. Everything is already
		// loaded, so this only widens the window - there is no request to wait on.
		// ng-table redraws every row, not just the new ones, so the list loses its place and the browser
		// lands at the end of the new rows. Put back where the user was - the bottom of the rows they had -
		// once the redraw is on the page, so they carry on reading down into the new ones.
		$scope.showMoreDocuments = function () {
			if (!$scope.tableParams || !$scope.hasMoreDocuments()) return;

			const list = $element[0].querySelector(".documents-scroll-container");
			const keep = list ? list.scrollTop : null;

			visibleDocumentCount += DOCUMENTS_WINDOW_SIZE;
			$scope.tableParams.parameters({ count: visibleDocumentCount, page: 1 });
			$q.when($scope.tableParams.reload()).then(function () {
				$timeout(function () {
					if (list && keep !== null) list.scrollTop = keep;
				}, 0, false);
			});
		};

		function buildTableFilters() {
			$scope.documentFilter = buildFilterArray('document_name');
			$scope.dateArray = buildFilterArray('document_created_date', true);
		}

		function buildFilterArray(property, isDate = false) {
			return $scope.DocumentList.reduce((acc, current) => {
				let title = isDate ? '20' + current[property].slice(-2) : current[property];
				if (!acc.some(t => t.title === title)) acc.push({ id: title, title: title });
				return acc;
			}, [{ id: '', title: 'All' }]);
		}

		const reg = new RegExp('^[0-9]{2}/[0-9]{2}/[0-9]{2}$');
		function applyComparer(actual, expected) {
			if (expected === "Phaco and IOL") return angular.equals(actual, expected);
			if (reg.test(actual)) return angular.equals(actual.slice(-2), String(expected).slice(-2));
			return actual.toLowerCase().includes(expected.toLowerCase());
		}

		$scope.$watch("checkboxes", function (newValue, oldValue) {
			if (newValue && $scope.$ctrl.selectionCallback) {
				const selectedCount = Object.values(newValue.items).filter(Boolean).length;
				if (selectedCount > $scope.MAX_FILES_NUMBER) {
					$scope.checkboxes = oldValue;
					$scope.selectedFilesError = true;
				} else {
					$scope.selectedFilesError = false;
					$scope.$ctrl.selectionCallback({ selection: newValue });
				}
			}
		}, true);

		// --- DOCUMENT ACTIONS (DOWNLOAD, PREVIEW, DELETE, RESTORE) ---
		// Every document - generated or uploaded - is asked for under the patient its row was listed
		// against rather than whoever is bound to the component now. The list is kept in step with the
		// binding above, so the two agree; carrying the row's own patient through means a request
		// stands on its own even if they ever come apart again. Documents are stored per patient, so
		// asking under the wrong one finds nothing and the document reads as missing when it is simply
		// someone else's.
		//
		// fileName is the file's full name, not the shortened one the row displays. It is what the
		// download is saved as, so a shortened name loses the extension and the saved file will not
		// open; it is also what the file's type is read from, so a video whose name was shortened
		// past its extension was asked for as a document, which is not how a video is served.
		$scope.downloadPDF = function (document_id, document_type, fileName, patientId) {
			if (document_type === 'upload') {
				$scope.fileAPI.isProcessing = true;
				const filePatientId = patientId || $scope.$ctrl.patient.id;
				const downloadPromise = patientDocumentService.isVideoFile(fileName)
					? $scope.fileAPI.fetchVideoUrl(filePatientId, document_id).then(res => $scope.fileAPI.downloadVideoFile(res.data))
					: $scope.fileAPI.downloadFile(filePatientId, document_id);

				downloadPromise.then(resp => patientDocumentService.executeFileDownload(resp.data, fileName))
					.catch(err => console.error("File download failed:", err && err.status))
					.finally(() => $scope.fileAPI.isProcessing = false);
				return;
			}

			$scope.PA.downloadDocument(patientId || $scope.$ctrl.patient.id, document_id, document_type)
				.then(resp => patientDocumentService.executeFileDownload(resp.data, patientDocumentService.getGeneratedFileName($scope.$ctrl.patient, document_type)))
				.catch(showServerError);
		};

		$scope.previewPDF = function (document_id, document_type, fileName, patientId) {
			if ($scope.isPreviewLoading) return; // Prevent multiple clicks

			$scope.isPreviewLoading = true; // Engage the lock

			// FAIL-SAFE: Forcefully release the lock after 15 seconds if the network hangs
			const safetyUnlock = $timeout(() => {
				if ($scope.isPreviewLoading) {
					console.warn("Preview operation timed out. Releasing UI lock.");
					$scope.isPreviewLoading = false;
				}
			}, 15000);

			const releaseLock = () => {
				$timeout.cancel(safetyUnlock);
				$scope.isPreviewLoading = false;
			};

			if (document_type === 'upload') {
				handleUploadPreview(document_id, fileName, patientId || $scope.$ctrl.patient.id).finally(releaseLock);
				return;
			}

			openPreviewModal(
				'pdf-viewer.tpl.html',
				'DOCUMENT PREVIEW',
				() => $scope.PA.downloadDocument(patientId || $scope.$ctrl.patient.id, document_id, document_type),
				'application/pdf',
				'pdfUrl'
			).finally(releaseLock);
		};

		function handleUploadPreview(document_id, fileName, filePatientId) {
			if (patientDocumentService.isPdfFile(fileName)) {
				return openPreviewModal('pdf-viewer.tpl.html', 'DOCUMENT PREVIEW', () => $scope.fileAPI.downloadFile(filePatientId, document_id), 'application/pdf', 'pdfUrl');
			} else if (patientDocumentService.isVideoFile(fileName)) {
				return openVideoPreview(document_id, filePatientId);
			} else if (patientDocumentService.isImageFile(fileName)) {
				return openPreviewModal('image-viewer.tpl.html', 'IMAGE PREVIEW', () => $scope.fileAPI.downloadFile(filePatientId, document_id), 'octet/stream', 'imageFileUrl');
			} else if (patientDocumentService.isWordFile(fileName) || patientDocumentService.isTXTFile(fileName)) {
				return openPreviewModal('word-viewer.tpl.html', 'DOCUMENT PREVIEW', () => $scope.fileAPI.downloadFile(filePatientId, document_id), 'octet/stream', null, true, fileName);
			}
			return Promise.resolve();
		}

		function openVideoPreview(document_id, filePatientId) {
			if ($scope.videoViewerModal) return Promise.resolve(); // Abort if already open

			$scope.loading = 'loading';
			$scope.videoUrl = null;

			$scope.videoViewerModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.video-viewer.tpl.html",
				show: true,
				title: "VIDEO PREVIEW",
				backdrop: true,
				keyboard: false
			});

			return $scope.fileAPI.fetchVideoUrl(filePatientId || $scope.$ctrl.patient.id, document_id).then(data => {
				if (!$scope.videoViewerModal) return;

				if (data.status === 200 || data.status === 202) {
					$scope.videoUrl = data.data;
					$scope.config = patientDocumentService.getVideoConfig($scope.videoUrl);
				} else {
					throw new Error("Could not retrieve video URL.");
				}
			}).catch(err => {
				console.error("Error fetching video URL:", err && err.status);

				$timeout(() => {
					$scope.loading = '';
					showServerError();
				});
			}).finally(() => {
				$timeout(() => {
					$scope.loading = '';
				});
			});
		}

		function openPreviewModal(template, title, promiseFn, mimeType, urlScopeVar, isWord = false, fileName = null) {
			const modalTarget = `${urlScopeVar || 'word'}ViewerModal`;

			// Abort if already open
			if ($scope[modalTarget]) return Promise.resolve();

			// Set loading state and clear old URLs immediately
			$scope.loading = 'loading';
			if (urlScopeVar) $scope[urlScopeVar] = null;

			// Open the modal IMMEDIATELY before the network request fires
			$scope[modalTarget] = $modal({
				scope: $scope,
				templateUrl: `app/src/views/templates/modal.${template}`,
				show: true,
				title: title,
				backdrop: true,
				keyboard: false
			});

			// Execute the network download
			return promiseFn().then(resp => {
				if (!$scope[modalTarget]) return;

				$timeout(() => {
					// Closed in the meantime: a URL made now would never be revoked.
					if (!$scope[modalTarget]) return;
					if (urlScopeVar) {
						$scope[urlScopeVar] = URL.createObjectURL(new Blob([resp.data], { type: mimeType }));
					}
					if (isWord) {
						patientDocumentService.handleFileSelect(new Blob([resp.data], { type: mimeType }), patientDocumentService.isTXTFile(fileName));
					}
				}, 200);
			}).catch(err => {
				console.error("File preview download failed:", err && err.status);

				$timeout(() => {
					$scope.loading = '';
					showServerError();
				});
			}).finally(() => {
				$timeout(() => {
					$scope.loading = '';
				});
			});
		}

		// --- MODAL CLOSERS (Triggers native AngularStrap hiding pipeline) ---
		$scope.closePdfViewer = () => {
			if ($scope.pdfUrlViewerModal) $scope.pdfUrlViewerModal.hide();
			if ($scope.pdfViewerModal) $scope.pdfViewerModal.hide();
			if ($scope.pdfUrl) {
				URL.revokeObjectURL($scope.pdfUrl);
				$scope.pdfUrl = null;
			}
		};
		$scope.closeVideoViewer = () => { if ($scope.videoViewerModal) $scope.videoViewerModal.hide(); };
		$scope.closeImageViewer = () => { if ($scope.imageFileUrlViewerModal) $scope.imageFileUrlViewerModal.hide(); };
		$scope.closeWordViewer = () => { if ($scope.wordViewerModal) $scope.wordViewerModal.hide(); };

		// --- NATIVE INTERCEPTOR FOR DISMISSALS (Backdrop clicks, Esc keys, and Close button calls) ---
		$scope.$on('modal.hide', function (event, modalInstance) {
			if ($scope.pdfUrlViewerModal && modalInstance === $scope.pdfUrlViewerModal) {
				cleanupModalState('pdfUrlViewerModal', 'pdfUrl');
			} else if ($scope.pdfViewerModal && modalInstance === $scope.pdfViewerModal) {
				cleanupModalState('pdfViewerModal', 'pdfUrl');
			} else if ($scope.videoViewerModal && modalInstance === $scope.videoViewerModal) {
				cleanupModalState('videoViewerModal', 'videoUrl');
			} else if ($scope.imageFileUrlViewerModal && modalInstance === $scope.imageFileUrlViewerModal) {
				cleanupModalState('imageFileUrlViewerModal', 'imageFileUrl');
			} else if ($scope.wordViewerModal && modalInstance === $scope.wordViewerModal) {
				cleanupModalState('wordViewerModal', null);
			}
		});

		// Core logic to nullify scope references and garbage collect active file blobs
		function cleanupModalState(modalVar, urlVar) {
			const oldUrl = urlVar ? $scope[urlVar] : null;
			if (urlVar) $scope[urlVar] = null;
			$scope[modalVar] = null;

			if (oldUrl && oldUrl.startsWith('blob:')) {
				$timeout(() => {
					URL.revokeObjectURL(oldUrl);
				}, 500);
			}
		}

		// --- FILE UPDATE FLOW ---
		$scope.updateFile = function (file) {
			if (!file.file_upload_date) {
				// Handle system Progress Note visibility toggle
				$scope.tooltipHide = true;
				$scope.PN.updateVisibility($scope.$ctrl.patient.id, file.document_id, file.document_security_type === "PRACTICE" ? "GLOBAL" : "PRACTICE")
					.then(fetchPatientDocumentsAndFiles).finally(() => $scope.tooltipHide = false);
				return;
			}

			$scope.tooltipHide = true;
			$scope.selectedFile = file;

			let fullDocName = file.full_name || file.file_name;
			let lastDotIndex = fullDocName.lastIndexOf('.');
			let fName = lastDotIndex !== -1 ? fullDocName.substring(0, lastDotIndex) : fullDocName;
			let fSuffix = lastDotIndex !== -1 ? fullDocName.substring(lastDotIndex + 1) : "";

			const providerDetails = (file.referral_data && file.referral_data.provider_details) || {};

			$scope.newFileItem = {
				file: { name: fName, suffix: fSuffix },
				fileType: file.file_type,
				operative_eye: file.eye,
				dateOfConsultation: $filter("date")(file.date_time, "dd/MM/yyyy"),
				security_level: file.security_level,
				// Shown as they stand so they can be corrected rather than re-entered from nothing.
				referral_provider_id: providerDetails.provider_id || '',
				referral_period: providerDetails.referral_period || '',
				referral_period_months: providerDetails.referral_period_months || '',
			};

			$scope.fileOptions = patientDocumentService.getFileOptions(file.file_mime_type, FILE_TYPES);
			if (!$scope.fileOptions) {
				$scope.fileOptions = FILE_TYPES.image;
			}

			const selectedType = $scope.fileOptions.find((t) => t.id === file.file_type);

			if (!selectedType) {
				$scope.alertMessage = `We cannot find the file type: ${file.file_type}, please contact support.`;
				showServerError();
				return;
			}

			$scope.fileItem_fileType = { id: selectedType.id, name: selectedType.name };
			$scope.detailsModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.file-upload-details.tpl.html",
				controller: "fileDetailController",
				show: true,
				backdrop: "static",
				title: "Update File Details",
				resolve: {
					newFileItem: () => $scope.newFileItem,
					fileType: () => $scope.fileItem_fileType,
					fileOptions: () => $scope.fileOptions
				}
			});
		};

		$scope.updateFileConfirm = function () {
			// Guard against double submission: ignore further clicks while the update is
			// in flight (the Update button is also disabled until it resolves).
			if ($scope.isSubmitting) {
				return;
			}

			let body = patientDocumentService.buildFileUpdateBody($scope.selectedFile, $scope.newFileItem);
			if (Object.keys(body).length === 0) {
				closeUpdateModal();
				return;
			}

			$scope.isSubmitting = true;
			$scope.fileAPI.isProcessing = true;
			// Held before the update clears the selection, as the refresh below is what re-reads it.
			const updatedFileId = $scope.selectedFile.document_id;

			$scope.fileAPI.updateFile($scope.$ctrl.patient.id, updatedFileId, body)
				.then(function () {
					fetchPatientDocumentsAndFiles();
					// Editing a file's details hands it back to the analyser, so it is followed the
					// same way an upload is.
					watchFilesForAiAnalysis([updatedFileId]);
				})
				.catch(err => console.error("File update failed:", err && err.status))
				.finally(() => {
					$scope.fileAPI.isProcessing = false;
					$scope.isSubmitting = false;
					closeUpdateModal();
				});
		};

		$scope.cancelFileUpdate = closeUpdateModal;
		function closeUpdateModal() {
			$scope.tooltipHide = false;
			$scope.detailsModal?.hide();
		}

		// --- DELETION & RESTORATION ---
		$scope.deleteFile = function (fileId, fileName) {
			if ($scope.deleteFileItem == null) {
				$scope.deleteFileItem = fileId;
				$scope.errorModal = $modal({
					scope: $scope,
					templateUrl: "app/src/views/templates/modal.file-upload-delete.tpl.html",
					show: true,
					backdrop: "static",
					title: fileName ? `Delete ${fileName}` : "Delete File",
					onHide: function () {
						$scope.deleteFileItem = null;
					}
				});
			}
		};

		$scope.deleteFileConfirm = function () {
			$scope.errorModal.hide();
			$scope.fileAPI.isProcessing = true;
			const fileId = $scope.deleteFileItem;
			$scope.fileAPI.deleteFile($scope.$ctrl.patient.id, fileId)
				.then(function () {
					// Stop following it if it was still being analysed - asking after a file that is
					// gone only earns a not-found on the next poll.
					delete aiAnalysisExpiryByFileId[fileId];
					fetchPatientDocumentsAndFiles();
				})
				.finally(() => { $scope.fileAPI.isProcessing = false; $scope.deleteFileItem = null; });
		};

		$scope.clearFileDeleteConfirm = function () { $scope.deleteFileItem = null; $scope.errorModal.hide(); };

		$scope.isDeleteVisible = (document_type) => ['OPNOTE', 'PRESCRIPTION_NOTE', 'WORKUP'].includes(document_type);
		$scope.getDeleteSrc = (doc) => canChangeDocState(doc) ? "app/build/img/delete.svg" : "app/build/img/delete-disabled.svg";
		$scope.getRestoreSrc = (doc) => canChangeDocState(doc) ? "app/build/img/restore.svg" : "app/build/img/restore-disabled.svg";

		$scope.deleteDoc = (doc) => handleDocStateChange(doc, 'delete');
		$scope.restoreDoc = (doc) => handleDocStateChange(doc, 'restore');

		function isEPrescription(doc) {
			return doc.document_type === "PRESCRIPTION_NOTE" && doc.document_sub_type === "ELECTRONIC";
		}

		// Only the author may delete or restore their document, and an ePrescription cannot be deleted
		// at all once sent. Must match MedicationController.deletePrescriptionNote in CatTraxRestAPI,
		// which is the authoritative gate - this only stops a request it would refuse.
		function canChangeDocState(doc) {
			if (`${Session.userId}` !== `${doc.document_created_by_id}`) return false;
			return !!doc.document_deleted || !isEPrescription(doc);
		}

		function handleDocStateChange(doc, action) {
			if (!canChangeDocState(doc)) return;
			if ($scope.OperationAPI.isProcessing || $scope.MedicationAPI.isProcessing || $scope.SurgeryAPI.isProcessing) return;

			const type = doc.document_type;
			const id = doc.document_id;
			let apiCall;
			if (type === "OPNOTE") { $scope.OperationAPI.isProcessing = true; apiCall = action === 'delete' ? $scope.OperationAPI.deleteOpNote : $scope.OperationAPI.restoreOpNote; }
			else if (type === "PRESCRIPTION_NOTE") { $scope.MedicationAPI.isProcessing = true; apiCall = action === 'delete' ? $scope.MedicationAPI.deletePrescription : $scope.MedicationAPI.restorePrescription; }
			else if (type === "WORKUP") { $scope.SurgeryAPI.isProcessing = true; apiCall = action === 'delete' ? $scope.SurgeryAPI.deleteWorkup : $scope.SurgeryAPI.restoreWorkup; }

			if (apiCall) {
				apiCall($scope.$ctrl.patient.id, id)
					.then(fetchPatientDocumentsAndFiles)
					.catch(showServerError)
					.finally(() => { $scope.OperationAPI.isProcessing = false; $scope.MedicationAPI.isProcessing = false; $scope.SurgeryAPI.isProcessing = false; });
			}
		}

		// --- APPEND LOGIC ---
		$scope.showAppendButton = function (doc) {
			$scope.$ctrl.eventCallback({ document: patientDocumentService.buildAppendPayload(doc, $scope.$ctrl.patient.id, $scope.$ctrl.operationNoteList) });
		};

		// --- UPLOADER MODAL & QUEUE MANAGEMENT ---
		$scope.showFileUploaderModal = function () {
			$scope.isFileUnsaved = false;
			$scope.fileUploaderModal = $modal({ scope: $scope, templateUrl: "app/src/views/templates/modal.files-uploader.tpl.html", show: true, title: "UPLOAD FILES", backdrop: "static", keyboard: false });
		};

		$scope.fileUploaderCallback = function (unsaved, close, uploadedFileIds) {
			$scope.isFileUnsaved = unsaved;
			if (close) {
				$scope.isFileUnsaved = false;
				$scope.closeFileUploaderModal();
				// Followed until the analyser has finished with each of them, so their results
				// appear without the list being reloaded.
				watchFilesForAiAnalysis(uploadedFileIds);
			}
		};

		$scope.closeFileUploaderModal = function () {
			if ($scope.fileUploaderModal && !$scope.isFileUnsaved) {
				$scope.fileUploaderModal.hide();
				fetchPatientDocumentsAndFiles();
				return;
			}
			$scope.alertMessage = 'Are you sure to quit file upload ?';
			$scope.errorModal = $modal({ scope: $scope, templateUrl: "app/src/views/templates/modal.file-upload-error.tpl.html", show: true, title: "Files are not uploaded yet" });
		};

		$scope.closeFileUploadErrorModal = function () {
			if ('Are you sure to quit file upload ?' === $scope.alertMessage) $scope.fileUploaderModal.hide();
			$scope.alertMessage = null;
			$scope.errorModal.hide();
		};

		function showServerError() {
			$scope.serverErrorModal = $modal({ scope: $scope, templateUrl: "app/src/views/templates/modal.server-error.tpl.html", show: true, title: "CatTrax has encountered an error", onShow: () => $scope.tooltipHide = false });
		}

		$scope.startDicomViewer = () => $state.go("dicom-viewer");

		// --- DICOM WALK-IN WORKLIST ---
		$scope.MODALITIES = DICOM_MODALITIES;

		$scope.selectedModalities = function () {
			var codes = [];
			$scope.MODALITIES.forEach(function (m) {
				if ($scope.worklist && $scope.worklist.modalities && $scope.worklist.modalities[m.value]) codes.push(m.value);
			});
			return codes;
		};

		$scope.openWalkIn = function () {
			$scope.clinicians = [];
			$scope.worklistSaving = false;
			$scope.worklist = {
				patient: $scope.$ctrl.patient,
				modalities: {},
				assignedUserId: null,
				procedureDescription: "",
				notes: "",
			};

			// The clinician list is read through the calendar, so without it the walk-in simply goes unassigned.
			if (Session.hasPermission("SCHEDULE_APPOINTMENT_VIEW")) {
				AppointmentAPI.getAppointmentUsers().then(
					function (resp) {
						resp.data.forEach(function (user) {
							$scope.clinicians.push({
								name: user.firstName + " " + user.lastName + `${Number(Session.userId) === user.id ? ' (Me)' : ''}`,
								value: user.id,
							});
						});
					},
					function (err) {
						console.log(err);
					}
				);
			}

			$scope.worklistModal = $modal({ scope: $scope, templateUrl: "app/src/views/templates/modal.dicom-worklist.tpl.html", show: true, title: "Add to imaging worklist", backdrop: "static" });
		};

		$scope.submitWorklist = function () {
			var worklist = $scope.worklist;
			var modalities = $scope.selectedModalities();
			if (modalities.length === 0 || $scope.worklistSaving) return;
			$scope.worklistSaving = true;

			var payload = {
				patientId: worklist.patient.id,
				// One worklist is created per modality; they share the walk-in's accession number.
				modalities: modalities,
				procedureDescription: worklist.procedureDescription || null,
				assignedUserId: worklist.assignedUserId || null,
				notes: worklist.notes || null,
			};

			DicomWorklistAPI.createWorklistEntry(payload.patientId, payload).then(
				function (resp) {
					var result = resp.data || {};
					var patientName = worklist.patient.firstName + " " + worklist.patient.lastName;

					// One accession covers the whole walk-in; the modalities are what differ.
					var scheduled = (result.modalities || []).join(", ");
					var listed = result.accessionNumber
						? " (" + scheduled + ", accession " + result.accessionNumber + ")"
						: "";

					// delivered is true only when the worklist reached the Orthanc that answers the
					// scanner's query. False means it is stored and arrives on the next sync, so say
					// that rather than implying the patient can be scanned this second.
					toast.create({
						timeout: 5000,
						message: result.delivered
							? patientName + " is on the imaging worklist now" + listed + "."
							: patientName + " was added to the imaging worklist" + listed
								+ ", but has not reached the scanner yet.",
						className: result.delivered ? "alert-success" : "alert-info",
						dismissible: true,
					});
					$scope.worklistSaving = false;
					$scope.worklistModal.hide();
				},
				function () {
					toast.create({
						timeout: 5000,
						message: "Could not add to the imaging worklist. Please try again.",
						className: "alert-danger",
						dismissible: true,
					});
					$scope.worklistSaving = false;
				}
			);
		};

		$scope.cancelWorklist = function () {
			$scope.worklistModal.hide();
		};

		// Filter triggers
		$scope.filter = { date: false, document: false, pathway: false, clinician: false };
		$scope.triggerFilterDate = () => { $scope.filter.date = !$scope.filter.date; if (!$scope.filter.date) $scope.tableParams.filter()['document_created_date'] = ''; };
		$scope.triggerFilterDocument = () => { $scope.filter.document = !$scope.filter.document; if (!$scope.filter.document) $scope.tableParams.filter()['document_name'] = ''; };
		$scope.triggerFilterPathway = () => { $scope.filter.pathway = !$scope.filter.pathway; if (!$scope.filter.pathway) $scope.tableParams.filter()['pathway'] = ''; };
		$scope.triggerFilterClinician = () => { $scope.filter.clinician = !$scope.filter.clinician; if (!$scope.filter.clinician) $scope.tableParams.filter()['document_created_by_name'] = ''; };

		// --- ANGULAR FILE UPLOADER CONFIG ---
		$scope.queueNotEmpty = false;
		var uploader = $scope.uploader = new FileUploader({ queueLimit: 10 });

		uploader.filters.push({
			name: 'fileFilter',
			fn: (item) => patientDocumentService.isFileTypeSupported(item) && !patientDocumentService.isFileTooBig(item) && patientDocumentService.isFileNameValid(item)
		});

		$scope.$watch("uploader.queue.length", function (newValue) {
			$scope.$ctrl.filesCallback({ unsaved: newValue > 0 });
		}, true);

		uploader.onWhenAddingFileFailed = function () {
			$scope.alertMessage = 'File could not be added. It may be an unsupported type, too large (max 200MB), or have an invalid name.';
			$scope.errorModal = $modal({ scope: $scope, templateUrl: "app/src/views/templates/modal.file-upload-error.tpl.html", show: true, title: "File cannot be added" });
		};

		uploader.onAfterAddingFile = function (fileItem) {
			$scope.queueNotEmpty = true;

			// Clean the name of trailing OS numbers/parens so the backend receives a valid file name
			fileItem.file.name = fileItem.file.name.replace(/(\.[a-zA-Z0-9]{2,5})[\s\(\)-]*\d*[\s\(\)-]*$/, '$1');

			Object.assign(fileItem, {
				security_level: "GLOBAL",
				operative_eye: "OU",
				comment: '',
				dateOfConsultation: $filter("date")(new Date(), "dd/MM/yyyy"),
				fileType: 'AI_ANALYSIS',
				uploadPatientId: $scope.$ctrl.patient.id,
				url: ENV.API + `/api/files/patient/${$scope.$ctrl.patient.id}`,
				headers: { Authorization: "Bearer " + Session.token, "X-PRACTICE-ID": `${Session.practice.id}` }
			});
			fileItem.upload();
			document.getElementById("uploadCaptureInputFile").value = null;
		};

		uploader.onBeforeUploadItem = function (item) {
			item.formData = [
				{ 'fileName': item.file.name },
				{ 'confidential': false },
				{ 'comment': item.comment },
				{ 'securityLevel': item.security_level },
				{ 'eye': item.operative_eye },
				{ 'fileType': item.fileType },
				{ 'dateOfConsultation': patientDocumentService.convertDateOfConsultation(item.dateOfConsultation) },
			];
		};

		uploader.onSuccessItem = function (fileItem, response) {
			// Every file dropped here goes for analysis, so each is followed until its result comes
			// back rather than waiting for the list to be reloaded.
			// Only while the list is still the patient it was uploaded to.
			if (response && response.file_id && fileItem.uploadPatientId === boundPatientId()) {
				watchFilesForAiAnalysis([response.file_id]);
			}
			$timeout(() => { fileItem.remove(); uploader.progress = 0; });
		};

		uploader.onErrorItem = function (fileItem, response, status, headers) {
			// Extract the message from your backend payload
			fileItem.errorMessage = response?.message || response?.error || "Unknown server error.";
		};

		uploader.onCompleteAll = function () {
			fetchPatientDocumentsAndFiles();
			uploader.progress = 0;

			const failureItems = $scope.uploader.queue.filter(t => t.isError);

			if (failureItems.length > 0) {
				// Format a clear error message summarizing what failed
				let errorDetails = failureItems.map(item => `- ${item.file.name}: ${item.errorMessage}`).join('\n');

				$scope.alertMessage = `Some files failed to upload. Any successful files were still added to the patient record.\n\nErrors:\n${errorDetails}`;

				$scope.errorModal = $modal({
					scope: $scope,
					templateUrl: "app/src/views/templates/modal.file-upload-error.tpl.html",
					show: true,
					title: "Partial Upload Failure"
				});
				// Failed items deliberately remain in the queue so the user can see them
			} else {
				$scope.queueNotEmpty = false;
			}
		};

	}
]);